import React, { FC } from 'react';
import { Divider, DividerWrapper } from './HorizontalDivider.css';

export const HorizontalDivider: FC<{ maxWidth?: string; padding?: string }> = props => {
  const { maxWidth, padding } = props;
  return (
    <DividerWrapper maxWidth={maxWidth} padding={padding}>
      <Divider />
    </DividerWrapper>
  );
};
